import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/styles/style.css";
import "./App.css";
import Login from "./components/login/Login";
import NavBar from "./components/navBar/NavBar";
import { Routes, Route, useLocation } from "react-router-dom";
import Home from "./components/home/Home";
import ProtectedRoute from "./context/protectedRoute/ProtectedRoute";
import NotFound from "./components/notFound/NotFound";
import Footer from "./components/footer/Footer";
import Users from "./components/users/Users";
import Providers from "./components/providers/Providers";
import CreateProvider from "./components/providers/CreateProvider";
import { fieldsAddUser } from "./constants/addUser.constats";
import { useContext, useEffect, useState } from "react";
import {
  fetchClients,
  fetchCompanies,
  fetchLanguage,
  fetchMapInstallers,
  fetchPerfiles,
  fetchPermissions,
  fetchProjects,
  fetchWorksType,
  fetchStatusProviders,
  fetchStates,
  fetchSpecialties,
  fetchProfileInstallers,
} from "./components/functions/Functions";
import { UserContext } from "./context/userContext/UserContext";
import EditUser from "./components/users/EditUser";
import CreateUser from "./components/users/CreateUser";
import Installers from "./components/providers/Installers";
import CreateInstallers from "./components/providers/CreateInstallers";
import EditProvider from "./components/providers/EditProvider";
import EditInstaller from "./components/providers/EditInstaller";
import DocumentsInstaller from "./components/providers/DocumentsInstaller";
import "react-pdf/dist/esm/Page/TextLayer.css";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";
import InstallersDocumentsPage from "./components/providers/InstallersDocumentsPage";
import ProvidersPage from "./components/providers/ProvidersPage";
import MapProviders from "./components/providers/MapProvider";
import MapInstallers from "./components/providers/MapInstallers";
import DocumentsProvider from "./components/providers/DocumentsProvider";
import Projects from "./components/projects/Projects";
import CreateProject from "./components/projects/CreateProject";
import {
  fetchPermisionarios,
  getGafeteNumber,
} from "./components/functions/Projects";
import CreateClient from "./components/projects/CreateClient";
import EditClient from "./components/projects/EditClient";
import ProjectsPage from "./components/projects/ProjectsPage";
import ClientsPage from "./components/projects/ClientsPage";
import MapProjectsPage from "./components/projects/MapProjectsPage";
import WorkCenterPage from "./components/projects/WorkCenterPage";
import EditProject from "./components/projects/EditProject";
import EDTsPage from "./components/projects/EDTsPage";
import CreateEDT from "./components/projects/CreateEDT";
import NotificationsPage from "./components/notifications/NotificationsPage";
import SoporteDashboard from "./components/soporte/SoporteDashboard";
import SeleccionDeTransformadores from "./components/soporte/SeleccionDeTransformadores";
import DescargarReportePage from "./components/projects/DescargarReportePage";
import TelefonosDeContacto from "./components/soporte/TelefonosDeContacto";
import DirectorioCFE from "./components/soporte/DirectorioCFE";
import ManualesHESQ from "./components/soporte/ManualesHESQ";
import ManualesImplementacion from "./components/soporte/ManualesImplementacion";
import NormativaCFE from "./components/soporte/NormativaCFE";

function App() {
  const { user, setUser } = useContext(UserContext);
  const location = useLocation();
  const [perfiles, setPerfiles] = useState([]); // Almacenar perfiles
  const [companies, setCompanies] = useState([]); // Almacenar empresas
  const [typeWorks, setTypeWorks] = useState([]); // Almacenar tipo de trabajos
  const [language, setLanguage] = useState([]); // Almacenar idiomas
  const [permissions, setPermissions] = useState([]); // Almacenar permisos
  const [projects, setProjects] = useState([]); // Almacenar proyectos
  const [clients, setClients] = useState([]); // Almacenar clientes
  const [installersMap, setInstallerMap] = useState([]); // Almacenar clientes
  const [permisionarios, setPermisionarios] = useState([]); // Almacenar permisionarios
  const [status, setStatusProviders] = useState([]);
  const [specialties, setSpecialties] = useState([]);
  const [states, setStates] = useState([]);
  const [profileInstallers, setProfileInstallers] = useState([]);
  const [key, setKey] = useState(0);
  // Determina si el NavBar debe mostrarse
  const showNavBar = location.pathname !== "/";

  const API_URL = process.env.REACT_APP_API_URL || "https://check.gruponxt.com";
  useEffect(() => {
    if (showNavBar) {
      fetchPerfiles(API_URL, setPerfiles);
      fetchCompanies(API_URL, setCompanies);
      fetchWorksType(API_URL, setTypeWorks);
      fetchLanguage(API_URL, setLanguage);
      fetchPermissions(API_URL, setPermissions);
      fetchProjects(API_URL, setProjects);
      fetchProfileInstallers(API_URL, setProfileInstallers);
      fetchClients(API_URL, setClients);
      fetchStatusProviders(API_URL, setStatusProviders);
      fetchStates(API_URL, setStates);
      fetchSpecialties(API_URL, setSpecialties);
      fetchMapInstallers(API_URL, setInstallerMap);
      fetchPermisionarios(API_URL, setPermisionarios);
      getGafeteNumber(API_URL);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className="App">
      {showNavBar && <NavBar API_URL={API_URL} companies={companies} />}
      <div className="content">
        <Routes>
          <Route path="/" element={<Login />} />
          <Route
            path="/check"
            element={
              <ProtectedRoute>
                <Home API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios"
            element={
              <ProtectedRoute allowedRoles={["esAdministrador"]}>
                <Users API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esLiderSeguridad",
                  "esSeguridad",
                  "esAnalista",
                ]}
              >
                <Providers
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/instaladores"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esAnalista",
                ]}
              >
                <InstallersDocumentsPage
                  API_URL={API_URL}
                  user={user}
                  setUser={setUser}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/todos"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esLiderSeguridad",
                  "esSeguridad",
                  "esAnalista",
                ]}
              >
                <ProvidersPage
                  API_URL={API_URL}
                  user={user}
                  setUser={setUser}
                  perfiles={perfiles}
                  specialties={specialties}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/mapa"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esLiderSeguridad",
                  "esSeguridad",
                  "esAnalista",
                ]}
              >
                <MapProviders API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/instaladores/mapa"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esAnalista",
                ]}
              >
                <MapInstallers installersMap={installersMap} />
              </ProtectedRoute>
            }
          />
          <Route
            path="proveedores/instaladores/:empresaId"
            element={
              <ProtectedRoute
                allowedRoles={[
                  "esAdministrador",
                  "esJefeInformacion",
                  "esLiderImplementacion",
                  "esProjectManager",
                  "esLiderMedicion",
                  "esAnalista",
                ]}
              >
                <Installers API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="proveedores/instaladores/nuevo/:empresaId"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <CreateInstallers
                  API_URL={API_URL}
                  perfilInstaladorer={profileInstallers}
                  companies={companies}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/instaladores/editar/:id"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <EditInstaller
                  API_URL={API_URL}
                  perfilInstaladorer={profileInstallers}
                  companies={companies}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/instaladores/documentos/:id"
            element={
              <ProtectedRoute>
                <DocumentsInstaller API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios/nuevo"
            element={
              <ProtectedRoute allowedRoles={["esAdministrador"]}>
                <CreateUser
                  perfiles={perfiles}
                  fieldsAddUser={fieldsAddUser}
                  API_URL={API_URL}
                  companies={companies}
                  typeWorks={typeWorks}
                  language={language}
                  permissions={permissions}
                  projects={projects}
                  clients={clients}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/nuevo"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <CreateProvider
                  perfiles={perfiles}
                  API_URL={API_URL}
                  states={states}
                  specialties={specialties}
                  status={status}
                  language={language}
                  user={user}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/editar/:id"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <EditProvider
                  API_URL={API_URL}
                  states={states}
                  specialties={specialties}
                  status={status}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proveedores/documentos/:empresaId"
            element={
              <ProtectedRoute>
                <DocumentsProvider user={user} API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/usuarios/editar/:userId"
            element={
              <ProtectedRoute allowedRoles={["esAdministrador"]}>
                <EditUser
                  perfiles={perfiles}
                  fieldsAddUser={fieldsAddUser}
                  API_URL={API_URL}
                  companies={companies}
                  typeWorks={typeWorks}
                  language={language}
                  permissions={permissions}
                  projects={projects}
                  clients={clients}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos"
            element={
              <ProtectedRoute>
                <Projects
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                  clients={clients}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/todos"
            element={
              <ProtectedRoute>
                <WorkCenterPage
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                  clients={clients}
                  permisionarios={permisionarios}
                  projects={projects}
                  states={states}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/clientes"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <ClientsPage
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                  clients={clients}
                  permisionarios={permisionarios}
                  projects={projects}
                  states={states}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/mapa"
            element={
              <ProtectedRoute>
                <MapProjectsPage
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                  clients={clients}
                  permisionarios={permisionarios}
                  projects={projects}
                  states={states}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/centros"
            element={
              <ProtectedRoute>
                <ProjectsPage
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  specialties={specialties}
                  clients={clients}
                  permisionarios={permisionarios}
                  projects={projects}
                  states={states}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/edts"
            element={
              <ProtectedRoute>
                <EDTsPage API_URL={API_URL} typeWorks={typeWorks} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/edts/nuevo"
            element={
              <ProtectedRoute>
                <CreateEDT API_URL={API_URL} typeWorks={typeWorks} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/editar/:id"
            element={
              <ProtectedRoute>
                <EditProject
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  clients={clients}
                  projects={projects}
                  typeWorks={typeWorks}
                  permisionarios={permisionarios}
                  states={states}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/nuevo"
            element={
              <ProtectedRoute>
                <CreateProject
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  clients={clients}
                  projects={projects}
                  typeWorks={typeWorks}
                  permisionarios={permisionarios}
                  states={states}
                  setProjects={setProjects}
                  setClients={setClients}
                  setPermisionarios={setPermisionarios}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/cliente/nuevo"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <CreateClient
                  API_URL={API_URL}
                  installersMap={installersMap}
                  user={user}
                  setUser={setUser}
                  companies={companies}
                  perfiles={perfiles}
                  clients={clients}
                  projects={projects}
                  typeWorks={typeWorks}
                  permisionarios={permisionarios}
                  key={key}
                  setKey={setKey}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/cliente/editar/:id"
            element={
              <ProtectedRoute
                allowedRoles={["esAdministrador", "esJefeInformacion"]}
              >
                <EditClient
                  API_URL={API_URL}
                  clients={clients}
                  setKey={setKey}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/proyectos/descargar-reporte/:id"
            element={
              <ProtectedRoute>
                <DescargarReportePage API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notificaciones"
            element={
              <ProtectedRoute>
                <NotificationsPage
                  companies={companies}
                  user={user}
                  API_URL={API_URL}
                />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte"
            element={
              <ProtectedRoute>
                <SoporteDashboard API_URL={API_URL} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/seleccion-transformadores"
            element={
              <ProtectedRoute>
                <SeleccionDeTransformadores API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/telefonos-de-contacto"
            element={
              <ProtectedRoute>
                <TelefonosDeContacto API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/directorio-cfe"
            element={
              <ProtectedRoute>
                <DirectorioCFE API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/manuales-hesq"
            element={
              <ProtectedRoute>
                <ManualesHESQ API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/manuales-implementacion"
            element={
              <ProtectedRoute>
                <ManualesImplementacion API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route
            path="/soporte/normativa-cfe"
            element={
              <ProtectedRoute>
                <NormativaCFE API_URL={API_URL} user={user} />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
      {showNavBar && <Footer />}
    </div>
  );
}

export default App;
